module.exports = __webpack_public_path__ + "static/media/eye_hide.362c5731.svg";